import React, {Component} from 'react';
import TopHeader from '../template/TopHeader';
import {bookingActions, hairdresserActions, productAction, userActions} from "../../_actions";
import {connect} from "react-redux";
import DatePicker from "react-datepicker";
import dateFormat from "dateformat";
import PhoneInput from "react-phone-number-input";

    class AddClient extends Component {
        constructor(props) {
            super(props);

            this.state = {
                name:'',
                first_name:'',
                last_name:'',
                email:'',
                phoneNumber:'',
                note:'',
                emailMarketingConsent: false,
                smsMarketingConsent: false,
                dob:'',
                error:'',
                // Client exists modal state
                showClientExistsModal: false,
                existingClient: null,
                ownerInfo: null
            }
            this.addClient=this.addClient.bind(this);
            this.selectDob=this.selectDob.bind(this);
            this.cancelClient=this.cancelClient.bind(this);
            this.onChanged=this.onChanged.bind(this);
            this.handleViewClient=this.handleViewClient.bind(this);
            this.handleUpdateClient=this.handleUpdateClient.bind(this);
            this.closeClientExistsModal=this.closeClientExistsModal.bind(this);
        }

        componentDidMount() {
            var self = this;

            // Redirect /clients/add to the clients list with the add panel open
            if (self.props.match.path === "/clients/add") {
                self.props.history.replace({ pathname: '/clients', state: { openAddPanel: true } });
                return;
            }

            let params = {
                defaultRedirectTo:localStorage.getItem('defaultRedirectTo')
            };
            if (localStorage.getItem('accessToken')) {
                self.props.dispatch(userActions.profile(params))
            }else{
                this.props.history.push('/')
            }
        }

        addClient(){
            let self = this;
            let params = {};
            params.hairdresserId = localStorage.getItem('userId');
            params.name=this.state.first_name+" "+this.state.last_name;
            params.first_name=this.state.first_name;
            params.last_name=this.state.last_name;
            params.email=this.state.email;
            params.phoneNumber=this.state.phoneNumber;
            params.note=this.state.note;
            params.dob=this.state.dob?dateFormat(this.state.dob, 'dd-mm-yyyy'):""
            params.emailMarketingConsent=this.state.emailMarketingConsent;
            params.smsMarketingConsent=this.state.smsMarketingConsent;

            if (this.state.first_name === "" || this.state.first_name === undefined) {
                this.setState({
                    fNameError: 'Please enter first name'
                })
            } else if (this.state.last_name === "" || this.state.last_name === undefined) {
                this.setState({
                    lNameError: 'Please enter last name'
                })
            }
            // else if (this.state.email === "" || this.state.email === undefined) {
            //     this.setState({
            //         emailError: "Please enter email address"
            //     })
            // }
            else if (this.state.email !== ""&&!this.validateEmail(this.state.email)) {
                this.setState({
                    emailError: 'Please enter a valid email address'
                })
            } else {
                self.props.dispatch(hairdresserActions.createClient(params))
                    .then(function (response) {
                        console.log('client response', response);

                        // Handle both old API (data) and new API (responseData) response structures
                        const responseData = response.data.responseData || response.data.data || response.data;

                        if (response.data.errorCode) {
                            if(response.data.errorCode==51){
                                self.setState({
                                    emailError: response.data.messages
                                })
                            }else{
                                self.setState({
                                    error: response.data.messages
                                })
                            }
                        } else if (responseData && responseData.clientExists) {
                            // Client already exists - show modal with options
                            self.setState({
                                showClientExistsModal: true,
                                existingClient: responseData.existingClient,
                                ownerInfo: responseData.ownerInfo
                            });
                        } else {
                            let params1 = {
                                searchKey: '',
                                hairdresserId: localStorage.getItem('userId'),
                                page: 1,
                                listType: 1,
                                isDownload: 0,
                            };
                            // Refresh client list in background (don't block navigation)
                            self.getHairdresserClient(params1).catch(err => {
                                console.log('Error refreshing client list:', err);
                            });
                            
                            if(self.props.match.path=="/clients/booking/add"){
                                // self.props.history.push('/newbooking/' + localStorage.getItem('salonId'))
                                if(self.props.hairdresserNewBookingStaff?._id) {
                                    let { state } = self?.props?.location;
                                    if (state) {
                                        let {pageLoadingStatus, previousPageUrl, start} = state;
                                        let selectedClient = responseData?.client || responseData;
                                        self.props.dispatch(productAction.selectedClient(selectedClient));
                                        let currentPageUrl = self.props.history.location.pathname;
                                        const stateObj = self?.props?.location?.state;

                                        self.props.history.push({pathname: previousPageUrl,state: stateObj})
                                        //self.props.history.push('/select-client/' + self.props.hairdresserNewBookingStaff?._id + '/1', {searchQuery: self.state.first_name,pageLoadingStatus, previousPageUrl, start})
                                    }else{
                                        self.props.history.push('/newbooking/' + localStorage.getItem('salonId'))
                                    }
                                }else{
                                    self.props.history.push('/newbooking/' + localStorage.getItem('salonId'))
                                }
                            }else {
                                self.props.history.push('/clients')
                            }
                        }
                    })
                    .catch(function(err) {
                        console.error('Error creating client:', err);
                        self.setState({
                            error: 'An error occurred while creating the client. Please try again.'
                        });
                    });
            }
        }

        handleViewClient() {
            const { existingClient } = this.state;
            if (existingClient && existingClient._id) {
                this.props.history.push('/client/' + existingClient._id);
            }
        }

        handleUpdateClient() {
            const { existingClient } = this.state;
            if (existingClient && existingClient._id) {
                // Navigate to client detail page in edit mode
                this.props.history.push('/client/' + existingClient._id + '?edit=true');
            }
        }

        closeClientExistsModal() {
            this.setState({
                showClientExistsModal: false,
                existingClient: null,
                ownerInfo: null
            });
        }

        selectDob(e){
            this.setState({dob:e})
        }

        getHairdresserClient=(params)=> {
            var self = this;
            return self.props.dispatch(hairdresserActions.getHairdresserClient(params))
        }

        cancelClient(){
            let self=this;
            if(self.props.match.path=="/clients/booking/add"){
                if(self.props.hairdresserNewBookingStaff?._id) {
                    let { state } = self?.props?.location;
                    if (state) {
                        let {pageLoadingStatus, previousPageUrl, start} = state;
                        self.props.history.push('/select-client/' + self.props.hairdresserNewBookingStaff?._id + '/1',{pageLoadingStatus, previousPageUrl, start})
                    }else {
                        self.props.history.push('/newbooking/' + localStorage.getItem('salonId'))
                    }
                }else{
                    self.props.history.push('/newbooking/' + localStorage.getItem('salonId'))
                }
            }else {
                self.props.history.push('/clients')
            }
        }

        onChanged(e) {
            this.setState({ [e.target.name]: e.target.value, copied: false });

            if (e.target.name === 'email') {
                if (!this.validateEmail(e.target.value)) {
                    this.setState({
                        emailError: 'Please enter a valid email address'
                    })
                } else {
                    this.setState({
                        emailError: ''
                    })
                }
            }

            if (e.target.name === 'first_name') {
                if (e.target.value === '' || e.target.value === null) {
                    this.setState({
                        fNameError: ''
                    })
                } else {
                    this.setState({
                        fNameError: '',
                    })
                }
            }

            if (e.target.name === 'last_name') {
                if (e.target.value === '' || e.target.value === null) {
                    this.setState({
                        fNameError: ''
                    })
                } else {
                    this.setState({
                        lNameError: '',
                    })
                }
            }
        }

        validateEmail(email) {
            const pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            const result = pattern.test(email);
            return result;
        }

        handlePhoneChange = val => {
            this.setState({phoneNumber: val})
            // if(!isValidPhoneNumber(val)) {
            //     this.setState({
            //         phoneNumberError: 'Please enter a valid phone number'
            //     })
            // }
        }


        render() {
            const { showClientExistsModal, existingClient, ownerInfo } = this.state;
            console.log("this.prop", this.props);
    return(
        <div className="h_n">
            <div className="body_container cm_bg_white">
                <TopHeader title="New Client" {...this.props} />


                <div className="container">

                    <div className="client_table p-4 mt-0">
                        {this.state.error ?
                            <span className="cm_error_msg">{this.state.error}</span> : ''}
                        <div className="row">

                            <div className="col-md-6 form-group">
                                <label>First Name</label>
                                <input type="text" className="form-control" name="first_name" value={this.state.first_name} onChange={this.onChanged}/>
                                {this.state.fNameError ?
                                    <span className="cm_error_msg">{this.state.fNameError}</span> : ''}
                            </div>

                            <div className="col-md-6 form-group">
                                <label>Surname</label>
                                <input type="text" className="form-control" name="last_name" value={this.state.last_name} onChange={this.onChanged}/>
                                {this.state.lNameError ?
                                    <span className="cm_error_msg">{this.state.lNameError}</span> : ''}
                            </div>

                            <div className="col-md-6 form-group">
                                <label>Email</label>
                                <input type="email" className="form-control" name="email" value={this.state.email} onChange={this.onChanged}/>
                                {this.state.emailError ?
                                    <span className="cm_error_msg">{this.state.emailError}</span> : ''}
                            </div>

                            <div className="col-md-6 form-group cm_PhoneInput">
                                <label>Mobile Number</label>
                                <PhoneInput
                                    international={true}
                                    defaultCountry="GB"
                                    country={"GB"}
                                    className="form-control"
                                    placeholder="Phone Number"
                                    name="phoneNumber"
                                    value={this.state.phoneNumber}
                                    onChange={this.handlePhoneChange}/>
                            </div>

                            <div className="col-md-12 form-group">
                                <label>Birthday</label>
                                <div className="cm_full_date">
                                <DatePicker
                                    dateFormat="dd/MM/yyyy"
                                    selected={this.state.dob}
                                    onChange={this.selectDob.bind(this)}
                                    className="form-control"
                                />
                                </div>
                            </div>

                            {/*<div className="col-md-6 form-group">*/}
                            {/*    <label>Birth Year</label>*/}
                            {/*    <input type="text" className="form-control" />*/}
                            {/*</div>*/}


                            <div className="col-md-12 form-group">
                                <label>Notes</label>
                                <textarea className="form-control" rows="6" name="note" value={this.state.note} onChange={this.onChanged}></textarea>
                            </div>

                            <div className="col-md-12 form-group">
                                <label>Marketing permission</label>
                                <p style={{ fontSize: '13px', color: '#8E8E93', margin: '0 0 10px' }}>
                                    Ask your client: "Are you happy to receive offers and news from us by email or text?" They can change their mind at any time.
                                </p>
                                <div className="form-check" style={{ marginBottom: '6px' }}>
                                    <input className="form-check-input" type="checkbox" id="emailMarketingConsent" checked={this.state.emailMarketingConsent} onChange={(e) => this.setState({ emailMarketingConsent: e.target.checked })} />
                                    <label className="form-check-label" htmlFor="emailMarketingConsent">Email marketing</label>
                                </div>
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" id="smsMarketingConsent" checked={this.state.smsMarketingConsent} onChange={(e) => this.setState({ smsMarketingConsent: e.target.checked })} />
                                    <label className="form-check-label" htmlFor="smsMarketingConsent">SMS marketing</label>
                                </div>
                            </div>




                        </div>

                    </div>

                            <div className="text-right mt-4">
                                <button className="btn btn-outline-dark pl-5 pr-5" onClick={this.cancelClient.bind(this)}>Cancel</button>
                                <button className="btn btn-dark ml-4 pl-5 pr-5" onClick={this.addClient.bind(this)}>Save</button>
                            </div>



                </div>



            </div>

            {/* Client Exists Modal */}
            {showClientExistsModal && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Client Already Exists</h5>
                                <button type="button" className="close" onClick={this.closeClientExistsModal}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="text-center mb-3">
                                    <i className="fa fa-exclamation-triangle text-warning" style={{ fontSize: '48px' }}></i>
                                </div>
                                <p className="text-center">
                                    A client with this email already exists in the salon.
                                </p>
                                {existingClient && (
                                    <div className="client-exists-info p-3 bg-light rounded mb-3">
                                        <p className="mb-1"><strong>Name:</strong> {existingClient.name || `${existingClient.first_name || ''} ${existingClient.last_name || ''}`}</p>
                                        <p className="mb-1"><strong>Email:</strong> {existingClient.email}</p>
                                        {existingClient.phoneNumber && (
                                            <p className="mb-1"><strong>Phone:</strong> {existingClient.phoneNumber}</p>
                                        )}
                                        {ownerInfo && ownerInfo.type !== 'own' && (
                                            <p className="mb-0 text-muted">
                                                <small>Added by: {ownerInfo.hairdresserName || ownerInfo.type}</small>
                                            </p>
                                        )}
                                    </div>
                                )}
                                <p className="text-center text-muted">
                                    Would you like to view or update this client's details?
                                </p>
                            </div>
                            <div className="modal-footer justify-content-center">
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary"
                                    onClick={this.closeClientExistsModal}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={this.handleViewClient}
                                >
                                    View Client
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-success"
                                    onClick={this.handleUpdateClient}
                                >
                                    Update Client
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
    }

function mapStateToProps(state) {
    return {
        ...state
    };
}

export default connect(mapStateToProps)(AddClient);
